import { CALL_API } from "../../middlewares/api";
import { get_affiliates } from "./queries";

export const CREATE_AFFILIATE_REQUEST = "CREATE_AFFILIATE_REQUEST";
export const CREATE_AFFILIATE_SUCCESS = "CREATE_AFFILIATE_SUCCESS";
export const CREATE_AFFILIATE_ERROR = "CREATE_AFFILIATE_ERROR";

export function create_affiliate(ownerPersonId, affiliateName) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/affiliates/add",
      method: "POST",
      authenticatedRequest: true,
      data: {
        OwnerPersonId: ownerPersonId,
        Name: affiliateName,
      },
      types: [
        CREATE_AFFILIATE_REQUEST,
        { method: get_affiliates_after_create_success },
        CREATE_AFFILIATE_ERROR,
      ],
    },
  };
}

function get_affiliates_after_create_success(response) {
  return (dispatch) => {
    dispatch({
      type: CREATE_AFFILIATE_SUCCESS,
      response,
    });
    dispatch(get_affiliates());
  };
}
